import { Offer } from "./types";

export const updateOffers = (updatedOffer: Offer, offers?: Offer[]) => {
  return offers?.map((offer) => {
    if (offer.identifier === updatedOffer.identifier) {
      return updatedOffer;
    }

    return offer;
  });
};

export const offersKeys = {
  list: ["offers"],
  getOne: (offerIdentifier: string) => ["offers", offerIdentifier],
};
